import React, { useState } from 'react'
import { LoginLink } from '@features/LoginModal/styles'
import LoginModal from '@features/LoginModal'
import useAuth from '@hooks/use-auth'
import { useTranslation } from 'react-i18next'
import { Button } from '@thriveglobal/thrive-ui-lib'
import Animation from '@elements/Animation'

export type NewNavLoginLinkProps = {
  buttonSize?: 'sm' | 'lg'
  navBarView?: boolean
}

export const NewNavLoginLink: React.FC<NewNavLoginLinkProps> = ({
  buttonSize,
  navBarView,
}) => {
  const [isModalVisible, setModalVisibility] = useState<boolean>(false)
  const { isAuthenticated, logout } = useAuth()
  const { t } = useTranslation()

  const handleLoginClick = async () => {
    if (isAuthenticated()) {
      await logout()
    } else {
      setModalVisibility(true)
    }
  }
  const authenticated = isAuthenticated()
  return (
    <React.Fragment>
      {authenticated && (
        <Animation duration={500}>
          {navBarView ? (
            <LoginLink data-testid={'logoutBtn'} onClick={handleLoginClick}>
              {t('navigation_bar')}
            </LoginLink>
          ) : (
            <Button
              data-testid={'logoutBtn'}
              size={buttonSize}
              onClick={handleLoginClick}
            >
              {t('navigation_bar')}
            </Button>
          )}
        </Animation>
      )}
      {!authenticated && (
        <Animation duration={500}>
          <Button
            data-testid={'loginBtn'}
            size={buttonSize}
            onClick={handleLoginClick}
          >
            {t('navigation_bar_login')}
          </Button>
        </Animation>
      )}
      {isModalVisible && (
        <LoginModal onClose={() => setModalVisibility(false)} />
      )}
    </React.Fragment>
  )
}

NewNavLoginLink.defaultProps = {
  buttonSize: 'sm',
  navBarView: true,
}
